import React, { useEffect, useState } from "react";
import "./ShopCard.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LikeItem from "../LikeItem/LikeItem";

const ShopCard = ({ product }) => {
  const navigate = useNavigate();
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  console.log("product: ", product);

  const [averageRating, setAverageRating] = useState(0);
  const [reviews, setReviews] = useState([]);

  const getReviewSystem = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getReviewById/${product._id}`,
      method: "get",
    };
    console.log(config);

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data);
        if (response?.data?.status) {
          const data = response.data;
          setReviews(data.data.reviews);
          setAverageRating(data.data.totalRating / data.data.ratingCount);
          // toast.success("Product added successfully", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          //   transitions: "Zoom",
          // });
          // navigate("/wishlist");
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            //   transitions: "Zoom",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const renderStars = (rating, setRating) => {
    const totalStars = 5;
    return (
      <div className="card-review">
        {[...Array(totalStars)].map((_, index) => {
          const starIndex = index + 1;
          return (
            <i
              key={index}
              className={
                rating >= starIndex
                  ? "bi bi-star-fill"
                  : rating >= starIndex - 0.5
                  ? "bi bi-star-half"
                  : "bi bi-star"
              }
              onClick={() => setRating(starIndex)}
              style={{ cursor: "pointer" }}
            ></i>
          );
        })}
      </div>
    );
  };

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    getReviewSystem();
  }, []);

  return (
    <>
      <div className="main-div-cards">
        <div className="card-div shadow">
          <div className="card-img">
            <img
              src={isHovered ? product?.image[1] : product?.image[0]} // Show second image on hover
              alt={product?.productName}
              onClick={() => {
                navigate(`/product/${product._id}`);
                window.scrollTo(0, 0);
              }}
              onMouseEnter={() => setIsHovered(true)} // Set hover state to true
              onMouseLeave={() => setIsHovered(false)} // Set hover state to false
            />
            <div className="likee">
              <LikeItem
                productIDdd={product?._id}
                IsLikedIte={product?.like?.some((like) => like._id === userId)}
              />
            </div>
          </div>

          <div className="detailsMain">
            <div className="details">
              <div className="details-para">
                <p
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    margin: "0",
                  }}
                >
                  {product?.productName}
                </p>
              </div>
            </div>

            <p className="card-textss">
              <h6>Rs. {Math.ceil(product?.price || 0)}/-</h6>
              <div className="discount-main">
                <del className="del">Rs.{product?.higherPrice}/-</del>{" "}
                <span className="flat20">Flat 20% off</span>
              </div>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopCard;
